module.exports = __webpack_public_path__ + "static/media/89.c2e47291.gif";